import React from "react";
import { Fade, Zoom } from "react-reveal";

const ProgressSlide = () => {
  return (
    <div className="text-left h-full w-full mx-auto py-10">
      <Zoom>
        <h1
          tabIndex={0}
          className="text-6xl text-white font-bold leading-0 text-center"
        >
          What <span className="text-accent">I Know</span>
        </h1>
      </Zoom>

      <div className="mx-auto flex flex-col justify-center items-center">
        <div className="w-5/6 md:w-4/6 lg:w-3/6 border-2 rounded-lg p-10 m-10 shadow-lg">
          <Fade left>
            <div className="mb-1 text-white font-medium">HTML</div>
            <div className="w-full mb-2 bg-gray-200 rounded-full h-4">
              <div
                className="bg-gray-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: "95%" }}
              >
                {" "}
                95%
              </div>
            </div>
          </Fade>

          <Fade right>
            <div className="mb-1 text-base font-medium text-white">CSS</div>
            <div className="w-full mb-2 bg-gray-200 rounded-full h-4">
              <div
                className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: "89%" }}
              >
                {" "}
                89%
              </div>
            </div>
          </Fade>

          <Fade left>
            <div className="mb-1 text-base font-medium text-white">
              Bootstrap
            </div>
            <div className="w-full mb-2 bg-gray-200 rounded-full h-4">
              <div
                className="bg-red-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: "90%" }}
              >
                {" "}
                90%
              </div>
            </div>
          </Fade>

          <Fade right>
            <div className="mb-1 text-base font-medium text-white">
              Tailwind
            </div>
            <div className="w-full mb-2 bg-gray-200 rounded-full h-4">
              <div
                className="bg-green-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: "90%" }}
              >
                {" "}
                90%
              </div>
            </div>
          </Fade>
          <Fade right>
            <div className="mb-1 text-base font-medium text-white">
              Material Ui
            </div>
            <div className="w-full mb-2 bg-gray-200 rounded-full h-4">
              <div
                className="bg-amber-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: "90%" }}
              >
                {" "}
                90%
              </div>
            </div>
          </Fade>

          <Fade left>
            <div className="mb-1 text-base font-medium text-white">
              JavaScript
            </div>
            <div className="w-full mb-2 bg-gray-200 rounded-full h-4">
              <div
                className="bg-yellow-400 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: "87%" }}
              >
                {" "}
                87%
              </div>
            </div>
          </Fade>
          <Fade left>
            <div className="mb-1 text-base font-medium text-white">ES6</div>
            <div className="w-full mb-2 bg-gray-200 rounded-full h-4">
              <div
                className="bg-sky-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: "87%" }}
              >
                {" "}
                87%
              </div>
            </div>
          </Fade>

          <Fade right>
            <div className="mb-1 text-base font-medium text-white">JQuery</div>
            <div className="w-full mb-2 bg-gray-200 rounded-full h-4">
              <div
                className="bg-indigo-900 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: "65%" }}
              >
                {" "}
                65%
              </div>
            </div>
          </Fade>

          <Fade left>
            <div className="mb-1 text-base font-medium text-white">React</div>
            <div className="w-full mb-2 bg-gray-200 rounded-full h-4">
              <div
                className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: "85%" }}
              >
                {" "}
                85%
              </div>
            </div>
          </Fade>

          <Fade right>
            <div className="mb-1 text-base font-medium text-white">Express</div>
            <div className="w-full mb-2 bg-gray-200 rounded-full h-4">
              <div
                className="bg-orange-500 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: "63%" }}
              >
                {" "}
                63%
              </div>
            </div>
          </Fade>

          <Fade left>
            <div className="mb-1 text-base font-medium text-white">Node</div>
            <div className="w-full mb-2 bg-gray-200 rounded-full h-4">
              <div
                className="bg-purple-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: "47%" }}
              >
                {" "}
                47%
              </div>
            </div>
          </Fade>
          <Fade left>
            <div className="mb-1 text-base font-medium text-white">MongoDB</div>
            <div className="w-full mb-2 bg-gray-200 rounded-full h-4">
              <div
                className="bg-cyan-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                style={{ width: "55%" }}
              >
                {" "}
                55%
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default ProgressSlide;
